import "./style.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useDebounce from "@hooks/useDebounce";
import storage from "@utils/storage";
import { useGetAllApplicationQuery } from "../../../../API/Applications";
import { defaultParams, statusColor } from "@utils/global.constants";
import lefticon from "../../../../Assets/Images/lefticon.svg";
import righticon from "../../../../Assets/Images/righticon.svg";

type Application = {
    uuid: string;
    lenderId: string;
    title: string;
    status: string;
    isDeleted: boolean;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
    offer: {
        uuid: string;
        title: string
        loanAmount: string;
        totalReturnAmount: string
        interestRate: string;
        loanDuration: string;
        termsAndConditions: string;
        status: string;
        createdAt: string
    };
};

function CompletedApplication() {
    const navigate = useNavigate();
    const Id = storage.getUser();
    const userId = Id.user.userId;
    const [color, seColor] = useState({ ...statusColor });

    const [params, setParams] = useState({
        ...defaultParams,
        limit: 1000,
        page: 1,
        search: "",
    });

    const debouncedSearch = useDebounce(params.search, 500);

    const { isLoading, data, isFetching, isError } = useGetAllApplicationQuery({
        userId,
        params,
    });

    const applications: Application[] = data?.applications || [];

    const completedOffers = applications.filter((app) => {
        const offerStatus = app.offer?.status?.toLowerCase();
        const appStatus = app.status?.toLowerCase();
        const title = app.offer?.title?.toLowerCase();
        const searchTerm = debouncedSearch?.toLowerCase() || "";

        return (
            offerStatus === "completed" &&
            (appStatus.includes(searchTerm) || title.includes(searchTerm))
        );
    });

    return (

        <div className="content completed-section">
            <div className="content-wrapper">
                <div className="title-block d-flex align-items-center justify-content-between">
                    <h5 className="m-0">Completed Applications</h5>
                </div>

                <div className="outer-box-wrapper">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="input-btn-fields d-flex align-items-center">
                        <div className="search-box">
                            <div className="input-search position-relative">
                                <input
                                    type="search"
                                    className="form-control"
                                    placeholder="Search"
                                    value={params.search}
                                    onChange={(e) =>
                                        setParams((prev) => ({ ...prev, search: e.target.value, page: 1 }))
                                    }
                                />
                                <div className="search-icon position-absolute">
                                    <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M13 13L9 9M1 5.66667C1 6.2795 1.12071 6.88634 1.35523 7.45252C1.58975 8.01871 1.93349 8.53316 2.36683 8.9665C2.80018 9.39984 3.31462 9.74358 3.88081 9.97811C4.447 10.2126 5.05383 10.3333 5.66667 10.3333C6.2795 10.3333 6.88634 10.2126 7.45252 9.97811C8.01871 9.74358 8.53316 9.39984 8.9665 8.9665C9.39984 8.53316 9.74358 8.01871 9.97811 7.45252C10.2126 6.88634 10.3333 6.2795 10.3333 5.66667C10.3333 5.05383 10.2126 4.447 9.97811 3.88081C9.74358 3.31462 9.39984 2.80018 8.9665 2.36683C8.53316 1.93349 8.01871 1.58975 7.45252 1.35523C6.88634 1.12071 6.2795 1 5.66667 1C5.05383 1 4.447 1.12071 3.88081 1.35523C3.31462 1.58975 2.80018 1.93349 2.36683 2.36683C1.93349 2.80018 1.58975 3.31462 1.35523 3.88081C1.12071 4.447 1 5.05383 1 5.66667Z"
                                            stroke="#8F95A2"
                                            strokeWidth="1.25"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div className="table-section rounded-3 overflow-auto">

                        <div className="table-responsive">
                            <table className="table align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th >Title</th>
                                        <th >Loan Amount</th>
                                        <th >Interest Rate</th>
                                        <th >Loan Duration</th>
                                        <th >Offer Date</th>
                                        <th >Applied Date</th>

                                        {/* <th>No. of applications</th> */}
                                        {/* <th>Status</th> */}
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading || isFetching ? (
                                        <tr>
                                            <td colSpan={8} className="text-center py-4">Loading...</td>
                                        </tr>
                                    ) : isError ? (
                                        <tr>
                                            <td colSpan={8} className="text-center text-danger py-4">Error loading applications.</td>
                                        </tr>
                                    ) : completedOffers?.length ? (
                                        completedOffers.map((application: { uuid: any; offer: { title: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal; loanAmount: any; interestRate: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal; loanDuration: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | React.ReactPortal; createdAt: string | number | Date; uuid: any; }; createdAt: string | number | Date; }, index: any) => (
                                            <tr key={application.uuid || index}>
                                                <td>{application.offer.title}</td>
                                                <td>£{Number(application.offer.loanAmount).toLocaleString()}</td>

                                                <td>{application.offer.interestRate}%</td>
                                                <td>{application.offer.loanDuration} months</td>
                                                <td>
                                                    {new Intl.DateTimeFormat("en-US", {
                                                        year: "numeric",
                                                        month: "short",
                                                        day: "numeric",
                                                    }).format(new Date(application.offer.createdAt))}
                                                </td>
                                                <td>
                                                    {new Intl.DateTimeFormat("en-US", {
                                                        year: "numeric",
                                                        month: "short",
                                                        day: "numeric",
                                                    }).format(new Date(application.createdAt))}
                                                </td>
                                                {/* <td>{String(application.offers.length).padStart(1, '0')}</td> */}
                                                {/* <td>
                                                    <span
                                                        style={{
                                                            color: color[application.status.toLowerCase()] || 'transparent', // Use color state
                                                            padding: '5px 10px',
                                                            borderRadius: '4px',
                                                        }}
                                                    >
                                                        {application.offer.status}
                                                    </span>
                                                </td> */}
                                                <td>
                                                    <div className="action-icons d-flex">
                                                        <a className="view"
                                                            // onClick={() =>
                                                            //     navigate("/app/view-applications", {
                                                            //         state: { applicationData: application },
                                                            //     })
                                                            // }
                                                            onClick={() => navigate("/app/review-offer", { state: { offerId: application.offer.uuid } })}
                                                        >
                                                            <svg
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M23.8474 11.5331C23.633 11.2398 18.5244 4.35156 11.9999 4.35156C5.47528 4.35156 0.366464 11.2398 0.152292 11.5328C0.0533293 11.6684 0 11.8319 0 11.9998C0 12.1676 0.0533293 12.3311 0.152292 12.4667C0.366464 12.76 5.47528 19.6482 11.9999 19.6482C18.5244 19.6482 23.633 12.76 23.8474 12.4669C23.9465 12.3314 23.9999 12.1679 23.9999 12C23.9999 11.8321 23.9465 11.6686 23.8474 11.5331ZM11.9999 18.0658C7.19381 18.0658 3.03126 13.494 1.79906 11.9994C3.02967 10.5034 7.18349 5.93397 11.9999 5.93397C16.8057 5.93397 20.9679 10.505 22.2007 12.0004C20.97 13.4963 16.8162 18.0658 11.9999 18.0658Z"
                                                                    fill="#2C3E50"
                                                                />
                                                                <path
                                                                    d="M12.0002 7.25244C9.3826 7.25244 7.25293 9.38211 7.25293 11.9997C7.25293 14.6173 9.3826 16.747 12.0002 16.747C14.6178 16.747 16.7475 14.6173 16.7475 11.9997C16.7475 9.38211 14.6178 7.25244 12.0002 7.25244ZM12.0002 15.1645C10.255 15.1645 8.83538 13.7448 8.83538 11.9997C8.83538 10.2546 10.2551 8.83489 12.0002 8.83489C13.7453 8.83489 15.165 10.2546 15.165 11.9997C15.165 13.7448 13.7454 15.1645 12.0002 15.1645Z"
                                                                    fill="#2C3E50"
                                                                />
                                                            </svg>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={8} className="text-center py-4">No applications found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className="pagination justify-content-end">
                            {data?.totalApplications > 0 && (
                                <div className="d-flex justify-content-end align-items-center mt-3 next-prev-btns mb-3">
                                    <div>
                                        {(() => {
                                            const startItem = (data.currentPage - 1) * params.pageSize + 1;
                                            const endItem = Math.min(startItem + params.pageSize - 1, data.totalApplications);
                                            return `${startItem}-${endItem} of ${data.totalApplications}`;
                                        })()}
                                    </div>

                                    <div className="d-flex gap-2">
                                        <button
                                            className="btn btn-outline-secondary p-0 previous-btn"
                                            disabled={data.currentPage === 1}
                                            onClick={() =>
                                                setParams(prev => ({
                                                    ...prev,
                                                    page: prev.page - 1,
                                                }))
                                            }
                                        >
                                            <img src={lefticon} alt="" />

                                        </button>

                                        <button
                                            className="btn btn-outline-secondary p-0 next-btn"
                                            disabled={data.currentPage >= data.totalPages}
                                            onClick={() =>
                                                setParams(prev => ({
                                                    ...prev,
                                                    page: prev.page + 1,
                                                }))
                                            }
                                        >
                                            {/* <img src={righticon} alt="" /> */}
                                            <img src={righticon} alt="" className="" />

                                        </button>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
}

export default CompletedApplication;